var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNawArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07191 11.2126L15.1594 0.209436C15.1962 0.180455 15.2404 0.162445 15.287 0.157473C15.3336 0.152502 15.3806 0.16077 15.4227 0.18133C15.4648 0.201889 15.5003 0.233906 15.525 0.273702C15.5497 0.313499 15.5627 0.359461 15.5625 0.406311V2.82194C15.5625 2.97506 15.4906 3.12194 15.3719 3.21569L4.1219 12.0001L15.3719 20.7844C15.4937 20.8782 15.5625 21.0251 15.5625 21.1782V23.5938C15.5625 23.8032 15.3219 23.9188 15.1594 23.7907L1.07191 12.7876C0.952175 12.6942 0.855315 12.5747 0.788694 12.4382C0.722073 12.3018 0.687445 12.1519 0.687445 12.0001C0.687445 11.8482 0.722073 11.6984 0.788694 11.5619C0.855315 11.4254 0.952175 11.306 1.07191 11.2126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNawArrow);
export default __webpack_public_path__ + "static/media/nawArrow.dcef80842b57c43c19efb920f73014b0.svg";
export { ForwardRef as ReactComponent };